<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>Formulario nuevo usuario</h3>
                    </div>
                </b-row>
                <DatosPrincipales v-if="instancia == 'datos_principales'" v-on:siguiente="set_instancia('empresas')" />
                <DadEmpresas v-if="instancia == 'empresas'" v-on:siguiente="set_instancia('sucursales')"
                    v-on:anterior="set_instancia('datos_principales')" />
                <DadSucursales v-if="instancia == 'sucursales'" v-on:anterior="set_instancia('empresas')"
                    v-on:salir="cerrar" />

            </b-container>
        </div>
    </div>
</template>

<script>
    import DatosPrincipales from './DatosPrincipales.vue'
    import DadEmpresas from './DadEmpresas.vue'
    import DadSucursales from './DadSucursales.vue'

    export default {
        name: 'FormularioNuevoUsuario',
        components: {
            DatosPrincipales,
            DadEmpresas,
            DadSucursales
        },
        data() {
            return {
                instancia: 'datos_principales',
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            set_instancia(instancia) {
                this.instancia = instancia
            }
        },
        mounted() {
            // Inicializar sucursalesDisponibles con una copia de las sucursales del store

        }
    }
</script>

<style></style>